import { createStyles } from "@envestnet/envreact-component-library";
import type { Theme, WithStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    orderedList: {
      paddingLeft: 18,
      marginTop: 32,
      marginBottom: 32,
      "& > li": {
        ...theme.fonts.p2,
        textAlign: "left",
        marginBottom: 16,
      },
    },
    linkButton: {
      paddingLeft: 0,
      marginTop: 32,
      float: "left",
    },
    nextButton: {
      marginTop: 32,
      width: "100%",
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
